import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Space } from "types/generated";
import { WORKER_POOL_CREATE_ACCESS_TYPES } from "shared/WorkerPool/access/useCanCreateWorkerPool";

const useWorkerPoolAvailableSpaces = (currentSpaceId?: string): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) => {
      if (space.id === currentSpaceId) {
        return true;
      }

      return hasAtLeastOneRequiredAction(WORKER_POOL_CREATE_ACCESS_TYPES, viewer, space.id);
    });
  }, [spaces, viewer, currentSpaceId]);

  return availableSpaces || [];
};

export default useWorkerPoolAvailableSpaces;
